import React from 'react';
import PageContainer from 'containers/PageContainer';
import PackageView from 'views/PackageView';
import moment from 'moment';
import { findNextAndPrevPack, mapPack } from 'helpers/subscriptionHelpers';
import useDisableReasons from 'hooks/useDisableReasons';

const PackageContainer = () => {
  const today = moment().format('YYYY-MM-DD');
  const { topupsDisableReason, changeUsageDisableReason } = useDisableReasons();

  const renderFunction = (
    subscription,
    account,
    store,
  ) => {
    const { nextPack, previousPack, nextDeliverablePack } = (subscription
      && findNextAndPrevPack(subscription.packs, today)) || {};

    const skippablePackId = (nextPack
      && nextPack.available_actions.includes('Holiday Pack')
      && nextPack.id)
      || '';

    const subscriptionExpiry = subscription.packs
      .flatMap((pack) => pack.payments)
      .map((payment) => payment.payment_date)
      .sort()
      .pop();

    const mappedPack = mapPack(nextDeliverablePack || previousPack, subscription, account, store);

    const hideChangeUsage = !mappedPack
    || !moment(mappedPack.deliveryDate).isAfter()
    || mappedPack.product.packSize.usage === 'Occasional'
    || (mappedPack.product.packSize.usage === 'Monthly'
      && !subscription.recommendedSolution);

    return (
      <PackageView
        subscriptionExpiry={subscriptionExpiry}
        memberSince={account.account.lens_mail_start_date}
        pack={mappedPack}
        changeUsageDisableReason={changeUsageDisableReason}
        skippablePackId={skippablePackId}
        canTopUp={!topupsDisableReason}
        nextPaymentAmount={subscription.next_payment_amount}
        hideChangeUsage={hideChangeUsage}
      />
    );
  };

  return (
    <PageContainer
      logoRef="/overview"
      requiresAccount
      requiresLogin
      displayNavBar
      requiresSubscription
      render={renderFunction}
    />
  );
};

PackageContainer.displayName = 'PackageContainer';

export default PackageContainer;
